/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { Children, cloneElement, Component } from 'react';
import PropTypes from "prop-types";
export class EuiValidatableControl extends Component {
  updateValidity() {
    if (this.control == null || typeof this.control.setCustomValidity !== 'function') {
      return; // jsdom doesn't polyfill this for the server-side
    }

    if (this.props.isInvalid) {
      this.control.setCustomValidity('Invalid');
    } else {
      this.control.setCustomValidity('');
    }
  }

  componentDidMount() {
    this.updateValidity();
  }

  componentDidUpdate() {
    this.updateValidity();
  }

  setRef = element => {
    this.control = element; // Call the original ref, if any

    const {
      ref
    } = this.props.children;

    if (typeof ref === 'function') {
      ref(element);
    }
  };

  render() {
    const child = Children.only(this.props.children);
    return cloneElement(child, {
      ref: this.setRef
    });
  }

}
EuiValidatableControl.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  isInvalid: PropTypes.bool,
  children: PropTypes.shape({
    ref: PropTypes.func
  }).isRequired
};

try {
  // @ts-ignore
  EuiValidatableControl.displayName = "EuiValidatableControl"; // @ts-ignore

  EuiValidatableControl.__docgenInfo = {
    "description": "",
    "displayName": "EuiValidatableControl",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-label": {
        "defaultValue": null,
        "description": "",
        "name": "aria-label",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "data-test-subj": {
        "defaultValue": null,
        "description": "",
        "name": "data-test-subj",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "isInvalid": {
        "defaultValue": null,
        "description": "",
        "name": "isInvalid",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/form/validatable_control/validatable_control.tsx#EuiValidatableControl"] = {
      docgenInfo: EuiValidatableControl.__docgenInfo,
      name: "EuiValidatableControl",
      path: "src/components/form/validatable_control/validatable_control.tsx#EuiValidatableControl"
    };
} catch (__react_docgen_typescript_loader_error) {}